<template>
  <iframe
    class="responsive-iframe"
    :src="homeDashboard"
    frameborder="0"
    style="border: 0"
    allowfullscreen
  ></iframe>
</template>

<script>
import Vue from "vue";
import { Auth, oAuth } from "../../../classes/Auth";
export default Vue.extend({
  name: "d5",
  props: {
    source: String,
  },
  data: () => ({
    homeDashboard: "",
    auth: new Auth(),
  }),
  mounted() {
    if (this.auth.getProject().name == "DAVIVIENDA") {
      this.homeDashboard ="https://datastudio.google.com/embed/reporting/c5beb694-4d81-4ba5-a60b-dd2a12c93cc8/page/hHWZB"
    }
    if (this.auth.getProject().name == "DAVIVIENDA II") {
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/e292e2d4-3451-49d3-ac0d-2b0e73519f64/page/1M"    }
    }
});
</script>


<style>
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>


